<template>
  <div>
    <vx-card class="h-full min-height">
      <div>
        <h4 class="">{{ $t("profile.ChangePassword") }}</h4>
        <vs-divider class="customer-divider my-4" />
      </div>
      <div class="flex w-full vx-row no-gutter justify-center height-300 mt-8">
        <div class="vx-col w-full sm:w-full md:w-full lg:w-10/12 xl:w-3/4">
          <form>
            <div class="mb-4">
              <vs-input
                ref="oldPassword"
                type="password"
                v-validate="'required'"
                name="item-oldPassword"
                :placeholder="$t('profile.OldPassword', { scolon: '' })"
                v-model="oldPassword"
                class="w-full"
                :label="$t('profile.OldPassword', { scolon: ':' })"
                color="warning"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('item-oldPassword')"
                >{{ $t("profile.OldPasswordError") }}</span
              >
            </div>
            <div class="mb-4">
              <vs-input
                ref="newPassword"
                type="password"
                v-validate="'required|min:8'"
                name="item-newPassword"
                :placeholder="$t('profile.NewPassword', { scolon: '' })"
                v-model="newPassword"
                class="w-full"
                :label="$t('profile.NewPassword', { scolon: ':' })"
                color="warning"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('item-newPassword')"
              >
                <span v-if="newPassword == ''">
                  {{ $t("profile.NewPasswordError") }}
                </span>
                <span v-if="newPassword.length < 8 && newPassword !== ''">
                  {{ $t("register.FormPasswordLength", { length: 8 }) }}
                </span>
              </span>
            </div>
            <div class="mb-4">
              <vs-input
                ref="againNewPassword"
                type="password"
                v-validate="'required|confirmed:newPassword'"
                name="item-againNewPassword"
                :placeholder="$t('profile.NewPassword', { scolon: '' })"
                v-model="againNewPassword"
                class="w-full"
                :label="$t('profile.NewPasswordSec', { scolon: ':' })"
                color="warning"
              />
              <span
                class="text-danger text-sm"
                v-show="
                  errors.has('item-againNewPassword') &&
                  errors.first('item-againNewPassword') !==
                    'The item-againNewPassword field is required'
                "
                >{{ $t("profile.NewPasswordNoMatch") }}</span
              >
              <span
                v-show="
                  !againNewPassword && errors.has('item-againNewPassword')
                "
                class="text-danger text-sm"
              >
                {{ $t("profile.NewPasswordSecError") }}
              </span>
            </div>
            <div class="text-center mt-8">
              <vs-button
                type="filled"
                color="warning"
                class="w-full"
                @click.prevent="submitForm"
                >{{ $t("profile.Accept")
                }}<feather-icon
                  class="ml-3 bx-spin"
                  :class="isChangePasswordLoading == true ? '' : 'd-none'"
                  icon="LoaderIcon"
                  svgClasses="w-5 h-5"
                ></feather-icon
              ></vs-button>
            </div>
          </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import i18n from '../../i18n/i18n.js'

export default {
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      againNewPassword: '',
      isChangePasswordLoading: false
    }
  },
  methods: {
    submitForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isChangePasswordLoading = true
          const data = [this.oldPassword, this.newPassword]
          this.$store
            .dispatch('updatePassword', data)
            .then(() => {
              this.isChangePasswordLoading = false
              this.$vs.notify({
                title: i18n.t('notifyAlert.success.title'),
                text: i18n.t('profile.PasswordUpdated'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success',
                position: 'top-right',
                time: 4000
              })
              localStorage.removeItem('userInfo')
              this.$store.dispatch('destroyToken')
              this.$router.push('/login')
            })
            .catch((error) => {
              this.isChangePasswordLoading = false
              this.errorMsg(error)
            })
        }
      })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group {
  .list-group-item {
    padding: 0.7rem 1.5rem;
    border-left: 2px solid transparent;

    .list-group-item-text {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
    }
    &.active {
      color: rgb(255, 159, 67);
      border-color: rgb(255, 159, 67);
    }
  }
}
.bg-light-primary {
  background: rgba(115, 103, 240, 0.12) !important;
}
.height-300 {
  min-height: 300px;
}
@media (min-width: 1350px) and (max-width: 1500px) {
  .xl\:w-1\/4 {
    width: 30% !important;
  }
  .xl\:w-3\/4 {
    width: 70% !important;
  }
}
@media (min-width: 1200px) and (max-width: 1349.9px) {
  .xl\:w-1\/4 {
    width: 35% !important;
  }
  .xl\:w-3\/4 {
    width: 65% !important;
    .xl\:w-3\/4 {
      width: 100% !important;
    }
  }
}

.avatar-icon {
  .feather-user {
    width: 50px;
    height: 50px;
  }
}
.min-height {
  min-height: 600px;
}
</style>
